import clsx from "clsx";
import Link from "next/link";
import { useMemo } from "react";
import { useSelector } from "react-redux";

import { SiteTypes } from "~/redux/reducers/paramsReducer";

import styles from "./index.module.scss";

export default function Breadcrumbs() {
  const { breadcrumbs }: any = useSelector((state: any) => state.breadcrumbs);
  const { siteType } = useSelector((state: any) => state.params);
  const isLanding = useMemo(() => {
    return siteType === SiteTypes.Landing;
  }, [siteType]);
  return (
    <nav className={clsx(isLanding && styles.BreadcrumbsContainer)}>
      <ol
        className={clsx(
          styles.Breadcrumbs,
          isLanding && styles.BreadcrumbsLanding,
        )}
        itemScope
        itemType="http://schema.org/BreadcrumbList"
      >
        {breadcrumbs.map((item: any, key: any) => (
          // eslint-disable-next-line react/jsx-no-useless-fragment
          <>
            {key === breadcrumbs.length - 1 ? (
              <li>
                <span>{item.name}</span>
              </li>
            ) : (
              <li
                key={item.name}
                itemProp="itemListElement"
                itemScope
                itemType="http://schema.org/ListItem"
              >
                <Link href={item.link}>
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a title={item.name} itemProp="item">
                    <span itemProp="name">{item.name}</span>
                    <span className={styles.Line} />
                  </a>
                </Link>
                <meta itemProp="position" content={key + 1} />
              </li>
            )}
          </>
        ))}
      </ol>
    </nav>
  );
}
